<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-row type="flex" style="margin-bottom:23px">
				<img src="@/assets/img/tag.png" alt="">
				<span class="title_a">检查登记</span>
			</el-row>
			<!-- 放置表单 -->
			<el-form ref="form" :model="form" label-width="auto" :rules="rules" class="form">
				<!-- 一 -->
				<el-row>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="检查机构" prop="jcjg">
							<el-cascader v-model="form.jcjg" :options="xzqhList" clearable :show-all-levels="false" filterable
								:props="defaultParams" style="width:100%">
							</el-cascader>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="检查人员" prop="jcr_xm">
							<el-input v-model="form.jcr_xm" size="large"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="职务" prop="jcr_zw">
							<el-input v-model="form.jcr_zw" size="large"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 二 -->
				<el-row>

					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="检查日期" prop="jcrq">
							<el-date-picker v-model="form.jcrq" type="datetime" placeholder="选择日期" style="width:100%"
								value-format="timestamp">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="是否合格" prop="jchg">
							<el-radio v-model="form.jchg" label="1">是</el-radio>
							<el-radio v-model="form.jchg" label="0">否</el-radio>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="场所负责人" prop="csfzr_xm">
							<el-input v-model="form.csfzr_xm" size="large"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 三 -->

				<el-row>

					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="检查类型" prop="jclxbm">
							<!-- <el-select v-model="form.jclxbm" placeholder="请选择检查类型" style="width: 100%;" filterable allow-create>
								<el-option v-for="item in jclxbmOptions" :key="item.title" :label="item.title" :value="item.title"
									:disabled="item.disabled" />
							</el-select> -->
							<el-autocomplete v-model="form.jclxbm" :fetch-suggestions="querySearchAsync" placeholder="若无预选类型,请直接输入"
								@select="handleSelect" style="width:100%">
							</el-autocomplete>
						</el-form-item>
					</el-col>

					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="发现问题" prop="csjc_jyqk">
							<el-input type="textarea" v-model="form.csjc_jyqk" size="large" :autosize="{ minRows: 1, maxRows: 4 }">
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="处理结果" prop="cljg_jyqk">
							<el-input type="textarea" v-model="form.cljg_jyqk" size="large" :autosize="{ minRows: 1, maxRows: 4 }">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="备注">
							<el-input type="textarea" v-model="form.jcbz" size="large" :autosize="{ minRows: 1, maxRows: 4 }">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" :lg="{ span: 23, offset: 1 }">
						<el-form-item label="检查照片" prop="jczp">
							<uploadImgs :imgsUploadObj="imgsUploadObj" @uploadimgFn="uploadimgFn" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!--  / 放置表单 -->

			<div style="text-align:center; margin-top: 51px;">
				<el-button type="info" @click="$router.back(-1)">返回</el-button>
				<el-button class="change" type="primary" @click="isOk">确定</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
// let id = 0
import { addDaliyItem, getzagldw } from '@/api/day_work'
import uploadImgs from '@/components/uploadImgs';
export default {
	name: 'AddDailyInspectionVue',
	data() {
		return {
			imgsUploadObj: {
				imgsKey: 'jczp', //字段名
				imgsString: '', //图片value字符串
				imgsList: [] //图片数组
			},
			breadcrumbList: [
				{ name: "公安机关日常检查", path: "daily_inspect" },
				{ name: "新增", path: "daily_inspect/add_daily_inspect" },
			],
			form: {
				jchg: '1', //是否合格 默认为是
				jczp: '',
			},
			xzqhList: [],
			loadAll() {
				return [
					{ value: "消防检查" },
					{ value: "治安检查" },
				]
			},
			defaultParams: {
				label: 'zagldwname',
				value: 'zagldwbm'
			},
			rules: {
				jcjg: [
					{ required: true, message: '请选择检查机构', trigger: 'change' },
				],
				jcrq: [
					{ required: true, message: '请选择检查日期', trigger: 'change' },
				],
				jchg: [
					{ required: true, message: '请选择是否合格', trigger: 'change' },
				],
				jclxbm: [
					{ required: true, message: '请填写检查类型', trigger: 'change' },
				],
				csfzr_xm: [
					{ required: true, message: '请输入场所负责人姓名', trigger: 'blur' },
				],
				jcr_zw: [
					{ required: true, message: '请输入检查人员职务', trigger: 'blur' },
				],
				jcr_xm: [
					{ required: true, message: '请输入检查人员姓名', trigger: 'blur' },
				],
				csjc_jyqk: [],
				cljg_jyqk: [],
				jczp: [{ required: true, message: '请至少上传一张检查照片', trigger: 'change' },]
			},
		}
	},
	components: {
		uploadImgs
	},
	async created() {
		this.xzqhList = await getzagldw({ isjc: 1 })
	},
	mounted() {
		this.restaurants = this.loadAll();
	},
	methods: {
		isOk() {// 确定提交表单

			console.log(this.form);
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					const addForm = {
						djxlh: this.form.djxlh,
						cs_dmsn: this.form.cs_dmsn,
						jcjg: this.form.jcjg[this.form.jcjg.length - 1],

						jcr_xm: this.form.jcr_xm,
						jcr_zw: this.form.jcr_zw,
						jcrq: this.form.jcrq ? this.form.jcrq / 1000 : '',

						jchg: this.form.jchg,
						csfzr_xm: this.form.csfzr_xm,
						csjc_jyqk: this.form.csjc_jyqk,

						jclxbm: this.form.jclxbm,
						cljg_jyqk: this.form.cljg_jyqk,
						jcbz: this.form.jcbz,

						jczp: this.form.jczp
					}
					this.loading = true

					await addDaliyItem(addForm)
					this.$message({
						showClose: true,
						message: '新增成功',
						type: 'success'
					})
					this.$router.push('/daily_inspect')
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		uploadimgFn(urlList, urlString) {
			console.log('父接收', urlList, urlString);
			this.form.jczp = urlString
			this.$refs['form'].validateField('jczp')
		},
		querySearchAsync(queryString, cb) {
			var restaurants = this.restaurants;
			var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

			cb(results);
			console.log(this.$refs['autocomplete']);
		},
		createStateFilter(queryString) {
			return (state) => {
				return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
			};
		},
		handleSelect(item) {
			console.log(item);
		}
	},
	watch: {
		'form.jchg'(newVal) {
			if (newVal == 0) {
				this.rules.csjc_jyqk = [
					{ required: true, message: '请输入发现问题', trigger: 'blur' },
				]
				this.rules.cljg_jyqk = [
					{ required: true, message: '请输入处理结果', trigger: 'blur' },
				]

			} else {
				this.rules.csjc_jyqk = []
				this.rules.cljg_jyqk = []
			}
		},

	},

}
</script>

<style lang="less"  scoped></style>